import { render, staticRenderFns } from "./InvoiceNewButton.vue?vue&type=template&id=300803b8&scoped=true&"
import script from "./InvoiceNewButton.vue?vue&type=script&lang=ts&"
export * from "./InvoiceNewButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300803b8",
  null
  
)

export default component.exports